import { render } from "./EditOnClick.vue?vue&type=template&id=df93fea4"
import script from "./EditOnClick.vue?vue&type=script&lang=js"
export * from "./EditOnClick.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__